import { render, staticRenderFns } from "./ServiceCgyGroup.vue?vue&type=template&id=e3796900&scoped=true&"
import script from "./ServiceCgyGroup.vue?vue&type=script&lang=js&"
export * from "./ServiceCgyGroup.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCgyGroup.vue?vue&type=style&index=0&id=e3796900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3796900",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent,VListItemGroup})
